<div class="wrapper">
  <mat-icon class="icon"> signal_wifi_statusbar_not_connected </mat-icon>
  <span class="accent">
    {{ 'ERR_NET_TITLE' | translate: [] : ErrNetTitleText }}:
  </span>
  <ng-container>
    @switch (error) {
      @case ('ws') {
        <span>
          {{ 'ERR_NET_COMMON' | translate: [] : ErrNetCommonText }}.
          {{ 'ERR_NET_WS' | translate: [] : ErrNetWSText }}
        </span>
      }
      @case ('http') {
        <span>
          {{ 'ERR_NET_COMMON' | translate: [] : ErrNetCommonText }}.
          {{ 'ERR_NET_HTTP' | translate: [] : ErrNetHttpText }}
        </span>
      }
      @case ('offline') {
        <span>
          {{ 'ERR_NET_COMMON' | translate: [] : ErrNetCommonText }}.
          {{ 'ERR_OFFLINE' | translate: [] : ErrNetOfflineText }}
        </span>
      }
      @default {
        <span>
          {{ 'ERR_NET_COMMON' | translate: [] : ErrNetCommonText }}
        </span>
      }
    }
  </ng-container>
</div>
